import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root_1 = $.from_html(`<span class="trend up svelte-mu0a2fo5su3j">↑</span>`);
var root_2 = $.from_html(`<span class="trend down svelte-mu0a2fo5su3j">↓</span>`);
var root = $.from_html(`<div class="stat-card svelte-mu0a2fo5su3j"><span class="stat-value svelte-mu0a2fo5su3j"> <!></span> <span class="stat-label svelte-mu0a2fo5su3j"> </span></div>`);

function StatCard($$anchor, $$props) {
	var div = root();
	var span = $.child(div);
	var text = $.child(span);
	var node = $.sibling(text);

	{
		var consequent = ($$anchor) => {
			var span_1 = root_1();

			$.append($$anchor, span_1);
		};

		var consequent_1 = ($$anchor) => {
			var span_2 = root_2();

			$.append($$anchor, span_2);
		};

		$.if(node, ($$render) => {
			if ($$props.trend === 'up') $$render(consequent); else if ($$props.trend === 'down') $$render(consequent_1, 1);
		});
	}

	$.reset(span);

	var span_3 = $.sibling(span, 2);
	var text_1 = $.child(span_3, true);

	$.reset(span_3);
	$.reset(div);

	$.template_effect(() => {
		$.set_text(text, `${$$props.value ?? ''} `);
		$.set_text(text_1, $$props.label);
	});

	$.append($$anchor, div);
}

if (import.meta.hot) {
	StatCard = $.hmr(StatCard);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-mu0a2fo5su3j');
		StatCard[$.HMR].update(module.default);
	});
}

export default StatCard;
import "bun-svelte:StatCard.svelte-17qw71hrlz8oo-style.css";